<template>
  <div v-if="currentUser && initialised">
    <template v-if="devices.length === 0">
      <b-card>
        <template #header>Enrolled Devices</template>
        <p class="text-center pt-4">No devices enrolled.</p>
      </b-card>
    </template>
    <template v-else>
      <b-card>
        <template #header>Devices</template>

        <table class="table table-striped table-hover">
          <thead>
            <tr>
              <th>Managed Apple Id</th>
              <th>JAMF Device Id</th>
              <th>Device Name</th>
              <th>Device Model</th>
              <th>OS Version</th>
              <th>BOLT Version</th>
              <th>Enrolled At</th>
              <th>Inventory Updated At</th>
              <th>Unenrolled At</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="device in devices" :key="device.id">
              <td>
                {{ device.managed_apple_id }}
              </td>
              <td>
                {{ device.jamf_id }}
              </td>
              <td>
                {{ device.device_name }}
              </td>
              <td>
                {{ device.device_model || "Unknown" }}
              </td>
              <td>
                {{ device.os_version }}
              </td>
              <td>
                {{ device.bolt_version || "" }}
              </td>
              <td>
                {{ formatLocalDate(device.enrolled_at) }}
              </td>
              <td>
                {{ formatLocalDate(device.inventory_updated_at) }}
              </td>
              <td>
                {{ device.unenrolled_at ? formatLocalDate(device.unenrolled_at) : "N/A" }}
              </td>
              <td>
                <b-button v-if="device.unenrolled_at" variant="danger" size="sm" disabled>
                  Unenrolled
                </b-button>
                <b-button
                  v-else
                  variant="danger"
                  size="sm"
                  @click.prevent="unenrollDevice(device.jamf_id)"
                >
                  Unenroll
                </b-button>
              </td>
            </tr>
          </tbody>
        </table>
      </b-card>
    </template>
  </div>
</template>

<script type="text/babel">
import format from "../../../mixins/format";

export default {
  mixins: [format],

  props: {
    currentUser: {
      required: true,
    },
  },

  data() {
    return {
      initialised: false,
      devices: [],
    };
  },

  mounted() {
    this.init();
  },

  methods: {
    async init() {
      this.devices = [];

      await this.load();

      this.initialised = true;
    },

    async load() {
      const response = await this.$http.get(`/users/${this.currentUser.id}/enrolled-devices`);

      if (response && response.body) {
        this.devices = response.body || [];
      }
    },

    async unenrollDevice(deviceId) {
      const choice = await window.sweetAlert({
        title: "Are you absolutely sure?",
        text: "This will un-enroll the device, this cannot be undone!",
        icon: "error",
        dangerMode: true,
        buttons: {
          cancel: "No",
          confirm: "Yes",
        },
      });
      if (choice) {
        const response = await this.$http.post(`/users/mobile-devices/${deviceId}/unenroll-device`);

        if (!response || response.status !== 200 || !response.body) {
          window.toastr.error(
            `Something went wrong when trying to unenroll this device, error: ${response?.body?.message}`,
            "Error"
          );
          return;
        }

        window.toastr.success("Successfully unenroll this device", "Success");
        await this.init();
      }
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.table td {
  vertical-align: middle;
}
</style>
